<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Tarihe Göre Hesap Ekstresi</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>



              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html İndir</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>



            </v-toolbar>
          </v-flex>


          <v-container fluid="">
            <v-layout row wrap>

              <v-flex xs12 sm4 md4 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">cached</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Borç
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ DevirBorc }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Alacak
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ DevirAlacak }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold"> Devir Bakiye: {{ DevirBakiye | bakiyekontrol }}
                    </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs12 sm4 md4 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">cached</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Borç
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ DonemBorc }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Alacak
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ DonemAlacak }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold"> Cari Dönem : {{ DonemBakiye | bakiyekontrol }} </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs12 sm4 md4 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">layers</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Borç
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ ToplamBorc }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  Alacak
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ ToplamAlacak }} &#8378;
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold">Genel Dönem : {{ ToplamBakiye | bakiyekontrol }} </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>


          <v-container fluid="">
            <v-card color="grey lighten-5" flat>
              <v-form ref="formtarih" v-model="valid" lazy-validation>
                <v-layout row wrap>
                  <v-flex xs12 sm4 md2>
                    <tarihcomp :etiket="'Başlangıç Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="date" v-model="date"></tarihcomp>
                  </v-flex>
                  <v-flex xs12 sm4 md2>
                    <tarihcomp :etiket="'Bitiş Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="date2" v-model="date2"></tarihcomp>
                  </v-flex>

                  <v-flex>
                    <v-layout>
                      <div v-if="load1">
                        <v-btn color="info" @click="getList()" fab small="" dark>
                          <v-icon>search</v-icon>
                        </v-btn>
                      </div>
                      <div v-if="load">
                        <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                      </div>
                      <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                        color="info" fab dark>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>Arama Filtresi Ekle</span>
                      </v-tooltip>


                    </v-layout>
                  </v-flex>

                </v-layout>
              </v-form>
            </v-card>

            <v-layout row="" wrap>
              <v-flex xs12 sm12 md12>
                <v-card>
                  <v-card-title>
                    <v-spacer></v-spacer>
                  </v-card-title>
                  <v-data-table :headers="headers" :pagination.sync="pagination" :rows-per-page-items=[50,100] :loading="progress"
                    :items="items" :search="search3">
                    <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-left">{{ props.item.Cari.Kod }}</td>
                      <td class="text-xs-left">{{ props.item.Cari.Unvan }}</td>
                      <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                      <td class="text-xs-left">{{ props.item.Evrak.Evrakkod }}</td>
                      <td class="text-xs-left">{{ props.item.Evrak.Evrakno}}</td>
                      <td class="text-xs-left">{{ props.item.Aciklama}}</td>
                      <td class="text-xs-left">{{ props.item.Vade | dateformat}}</td>
                      <td class="text-xs-right">{{ props.item.Borc | moneyformat}}</td>
                      <td class="text-xs-right">{{ props.item.Alacak | moneyformat}}</td>
                      <td class="text-xs-right">{{ props.item.Bakiye | bakiyekontrol}}</td>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                      Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                    </v-alert>
                  </v-data-table>
                </v-card>
                <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="800px">
                  <v-card color="grey lighten-5">

                    <v-card-title>Filtre Seçimi</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-layout row="" wrap="">

                        <v-flex pa-1 xs12 sm12 md6>
                          <v-card class="white--text">
                            <v-card color="grey lighten-5" flat="">
                              <v-card-actions>
                                <v-layout justify-space-between column>
                                  <v-select :items="Referans" clearable="" hide-details="" v-model="Ekstreinput.ReferansKodIstenilen.Kod"
                                    label="İstenilen Ref." item-text="ReferansAd" item-value="Kod" max-height="400"></v-select>
                                  <v-select :items="doviztipi" hide-details="" v-model="Ekstreinput.Doviz.DovizKod"
                                    label="Döviz Tipi" item-text="DovizAdi" item-value="DovizKod" max-height="400"></v-select>
                                </v-layout>
                              </v-card-actions>
                            </v-card>
                          </v-card>
                        </v-flex>

                        <v-flex pa-1 xs12 sm12 md6>
                          <v-card class="white--text">
                            <v-card color="grey lighten-5" flat="">
                              <v-card-actions>
                                <v-layout justify-space-between column>
                                  <v-select :items="Referans" clearable="" hide-details="" v-model="Ekstreinput.ReferansKodIstenmeyen.Kod"
                                    label="İstenmeyen Ref." item-text="ReferansAd" item-value="Kod" max-height="400"
                                    persistent-hint></v-select>
                                  <v-select :items="evraktipi" hide-details="" v-model="secilenevraklar" label="Evrak Cinsi"
                                    multiple="" item-text="Aciklama" clearable item-value="Evrakkod" max-height="400"></v-select>
                                </v-layout>
                              </v-card-actions>
                            </v-card>
                          </v-card>
                        </v-flex>

                        <v-flex pa-1 xs12 sm12 md12>
                          <v-card class="white--text">
                            <v-card color="grey lighten-5" flat="">
                              <v-card-actions>
                                <v-autocomplete v-model="Ekstreinput.AnaHesap" clearable="" label="Başlangıç Cari Seçiniz"
                                  append-icon="search" :loading="loading" :items="statecari" item-text="text"
                                  cache-items="" item-value="id" :search-input.sync="searchcari"></v-autocomplete>
                              </v-card-actions>
                            </v-card>
                          </v-card>
                        </v-flex>



                        <v-flex xs12 sm12 md12>

                          <v-card flat="" color="#9E9E9E">
                            <v-card-title>
                              <span class="subheading white--text font-weight-medium "> Seçenekler</span>
                            </v-card-title>
                          </v-card>
                        </v-flex>

                        <v-flex xs12 sm6 md6>
                          <v-layout justify-space-between column>
                            <v-checkbox v-model="Ekstreinput.DevirBakiye" label="Devir+Bakiye Gösterme" hide-details=""></v-checkbox>
                            <v-checkbox v-model="Ekstreinput.HesapAdi" label="Hesap Adını Göster" hide-details=""></v-checkbox>
                            <v-checkbox v-model="tumsirketler" label="Tüm Şirketler" hide-details=""></v-checkbox>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm3 md3>
                          <v-layout justify-space-between column>
                            <v-radio-group hide-details="" v-model="Ekstreinput.TarihSec" label="Tarih / Vade " column>
                              <v-radio label="Tarih" color="orange darken-3" value=false> </v-radio>
                              <v-radio label="Vade" color="orange darken-3" value=true></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm3 md3>
                          <v-layout justify-space-between column>
                            <v-radio-group hide-details="" v-model="Ekstreinput.Program" label="Program" column>
                              <v-radio label="Hepsi" value=0> </v-radio>
                              <v-radio label="Sadece COPER" value=1></v-radio>
                              <v-radio label="Coper Hariç" value=2></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>


                      </v-layout>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Filtreleri Uygula</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>


                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
                  :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                  {{ text1 }}
                  <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                </v-snackbar>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>

      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from '../customcomp/tarihim'

  export default {
    data() {
      return {
        search: '',
        headers: [{
            text: 'Cari Kod',
            value: 'Cari.Kod',
            sortable: false
          },
          {
            text: 'Ünvan',
            value: 'Cari.Unvan',
            sortable: false
          },
          {
            text: 'Tarih',
            value: 'Tarih'
          },
          {
            text: 'Evrak Tipi',
            value: 'Evrak.Evrakkod',
            sortable: false
          },
          {
            text: 'Evrak No',
            value: 'Evrakno',
            sortable: false
          },
          {
            text: 'Açıklama',
            value: 'Aciklama',
            sortable: false
          },
          {
            text: 'Vade Tarihi',
            value: 'Vade'
          },
          {
            text: 'Borç',
            value: 'Borc',
            sortable: false,
            align: 'right'
          },
          {
            text: 'Alacak',
            value: 'Alacak',
            sortable: false,
            align: 'right'
          },
          {
            text: 'Bakiye',
            value: 'Bakiye',
            sortable: false,
            align: 'right'
          }
        ],
        EkstreHesap: {
          Current: '',
          CurrentTitle: '',
          Date: '',
          DocumentType: '',
          DocumentNumber: '',
          Explanation: '',
          DueDate: '',
          Debt: '',
          Credit: '',
          Balance: '',
          BAType: ''
        },
        Ekstreinput: {
          BaslangicTarih: null,
          BitisTarih: null,
          ReferansKodIstenilen: {
            Kod: ''
          },
          ReferansKodIstenmeyen: {
            Kod: ''
          },
          Evraklar: [],
          AnaHesap: '',
          Doviz: {
            DovizKod: ''
          },
          TarihSec: false,
          DevirBakiye: false,
          HesapAdi: false,
          Program: 0,
          SirketKodu: 0
        },

        DonemBorc: 0,
        DonemAlacak: 0,
        DonemBakiye: 0,
        ToplamAlacak: 0,
        ToplamBorc: 0,
        ToplamBakiye: 0,
        DevirAlacak: 0,
        DevirBorc: 0,
        DevirBakiye: 0,

        StartDate: null,
        EndDate: null,
        statecari: [],
        searchcari: '',
        progress: false,

        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        Referans: [],
        evraktipi: [],
        secilenevraklar: [],
        doviztipi: [],
        anahesap: [],
        hesapgurubu: [],

        tumsirketler: false,
        dictionary: {
          custom: {
            masrafkodu: {
              required: () => 'Lütfen seçiminizi yapınız'
            },
            tarihsec: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsec1: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },
        pagination: {
          sortBy: 'Tarih'
        },
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        tooltip: false,
        el: null,
        valid: true,

      }
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)

      this.el = this.$refs.fab.$el

    },
    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    methods: {
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,

      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      carigetir: carigetir
    }
  }



  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }


    this.$http.post(auth.API_URL + 'api/Reference/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.Referans = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/currency/List', {}, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })


    this.$http.post(auth.API_URL + 'api/doctype/List', {}, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.evraktipi = response.body

    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })

  }

  function filtrekayit() {
    this.renk1 = 'orange darken-4'
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.renk1 = 'info'
    this.dialogfiltre = false
    this.Ekstreinput.BaslangicTarih = null,
      this.Ekstreinput.BitisTarih = null,
      this.Ekstreinput.ReferansKodIstenilen.Kod = null
    this.Ekstreinput.ReferansKodIstenmeyen.Kod = null
    this.Ekstreinput.Evraklar = []
    this.Ekstreinput.AnaHesap = ''
    this.Ekstreinput.Doviz.DovizKod = null
    this.Ekstreinput.TarihSec = false
    this.Ekstreinput.DevirBakiye = false
    this.Ekstreinput.HesapAdi = false
    this.Ekstreinput.Program = 0
    this.Ekstreinput.SirketKodu = 0
    this.tumsirketler = false

  }

  function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }

  function getList() {

    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.date)
      var bittarih = new Date(this.date2)

      if (bastarih <= bittarih) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.progress = true
        this.currentDebtTotal = 0
        this.currentCreditTotal = 0
        this.debtTotal = 0
        this.creditTotal = 0
        this.load1 = false




        if (this.secilenevraklar.length > 0) {
          this.secilenevraklar.forEach(element => {
            var evrak = {
              EvrakKod: element
            }
            this.Ekstreinput.Evraklar.push(evrak)
          });

        }

        this.Ekstreinput.BaslangicTarih = this.date
        this.Ekstreinput.BitisTarih = this.date2

        if (this.tumsirketler === true) {
          this.Ekstreinput.SirketKodu = 0
        } else {
          this.Ekstreinput.SirketKodu = credentials.SirketKodu
        }


        var params = this.Ekstreinput

        this.$http.post(auth.API_URL + 'api/Abstract/ListWithoutCurrent', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body.EkstreList
          this.text1 = 'toplam ' + response.body.EkstreList.length + ' kayıt bulundu..'
          this.snackbar = true

          this.DonemBorc = response.body.DonemBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          this.DonemAlacak = response.body.DonemAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          this.DonemBakiye = response.body.DonemBakiye

          this.ToplamAlacak = response.body.ToplamAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          this.ToplamBorc = response.body.ToplamBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          this.ToplamBakiye = response.body.ToplamBakiye

          this.DevirAlacak = response.body.DevirAlacak.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          this.DevirBorc = response.body.DevirBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          this.DevirBakiye = response.body.DevirBakiye

          this.load1 = true
          this.progress = false

        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false

          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false

          }
        })
      } else {
        this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
        this.snackbar = true
      }
    }
  }









  function getListHtml() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.progress = true
    this.currentDebtTotal = 0
    this.currentCreditTotal = 0
    this.debtTotal = 0
    this.creditTotal = 0
    this.load1 = false



    if (this.secilenevraklar.length > 0) {
      this.secilenevraklar.forEach(element => {
        var evrak = {
          EvrakKod: element
        }
        this.Ekstreinput.Evraklar.push(evrak)
      });

    }

    this.Ekstreinput.BaslangicTarih = this.date
    this.Ekstreinput.BitisTarih = this.date2

    if (this.tumsirketler === true) {
      this.Ekstreinput.SirketKodu = 0
    } else {
      this.Ekstreinput.SirketKodu = credentials.SirketKodu
    }


    var params = this.Ekstreinput




    this.$http.post(auth.API_URL + 'api/Abstract/ListWithoutCurrentHtml', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.load = false
      this.load1 = true
      this.progress = false
      var blob = new Blob([response.data], {
        type: 'application/html'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "TarihEkstre.html";
      link.click();

    }, (response) => {
      if (response.status === 0) {
        this.text = 'Service Unavailable'
        this.snackbar = true
        this.load1 = true
        this.progress = false

      } else {
        this.text = 'Service Unavailable'
        this.snackbar = true
        this.load1 = true
        this.progress = false

      }
    })
  }

  function getListExcel() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.progress = true
    this.currentDebtTotal = 0
    this.currentCreditTotal = 0
    this.debtTotal = 0
    this.creditTotal = 0
    this.load1 = false



    if (this.secilenevraklar.length > 0) {
      this.secilenevraklar.forEach(element => {
        var evrak = {
          EvrakKod: element
        }
        this.Ekstreinput.Evraklar.push(evrak)
      });

    }

    this.Ekstreinput.BaslangicTarih = this.date
    this.Ekstreinput.BitisTarih = this.date2

    if (this.tumsirketler === true) {
      this.Ekstreinput.SirketKodu = 0
    } else {
      this.Ekstreinput.SirketKodu = credentials.SirketKodu
    }


    var params = this.Ekstreinput




    this.$http.post(auth.API_URL + 'api/Abstract/ListWithoutCurrentExcel', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      },
      responseType: "arraybuffer"
    }).then((response) => {
      this.load = false
      this.load1 = true
      this.progress = false
      var blob = new Blob([response.data], {
        type: 'application/xlsx'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = "TarihEkstre.xlsx";
      link.click();

    }, (response) => {
      if (response.status === 0) {
        this.text = 'Service Unavailable'
        this.snackbar = true
        this.load1 = true
        this.progress = false

      } else {
        this.text = 'Service Unavailable'
        this.snackbar = true
        this.load1 = true
        this.progress = false

      }
    })
  }

  function beforeMount() {
    this.Ekstreinput.ReferansKodIstenilen.Kod = null
    this.Ekstreinput.ReferansKodIstenmeyen.Kod = null
  }
</script>

<style>
</style>